import type { PropertiesConfig } from '../config'

import { WebStorage } from './web'

/**
 * Uses {@link window.localStorage}
 */
export class LocalStorage<
  // NOTE: this must NOT have any default! If it does, it won't get inferred,
  // which breaks a lot
  const TPropertiesConfig extends PropertiesConfig.Constraint,
> extends WebStorage<TPropertiesConfig> {
  /**
   * Default name for a {@link LocalStorage}. If you have more than one
   * {@link LocalStorage} using the same
   * {@link LocalStorage.constructor.Params.parent}, you should pass
   * {@link LocalStorage.constructor.Params.name} to avoid collisions.
   */
  public static readonly DEFAULT_NAME = 'LocalStorage'

  /**
   * @see {@link window.localStorage}
   */
  public readonly storage = window.localStorage

  constructor(params: LocalStorage.constructor.Params<TPropertiesConfig>) {
    super({
      ...params,
      name: params.name ?? LocalStorage.DEFAULT_NAME,
    })
  }
}
export namespace LocalStorage {
  export namespace constructor {
    export interface Params<
      TPropertiesConfig extends PropertiesConfig.Constraint,
    > extends Partial.Semi<
        WebStorage.constructor.Params<TPropertiesConfig>,
        'name'
      > {}
  }
}
